import { type ReactNode, useId, useState } from 'react';
import styles from './Disclosure.module.scss';
import { ChevronDownIcon, ChevronUpIcon } from './icons';

export function Disclosure({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className={styles.disclosure}>
      <button
        type="button"
        className={styles.trigger}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{title}</span>
        {open ? (
          <ChevronUpIcon className={styles.chevron} />
        ) : (
          <ChevronDownIcon className={styles.chevron} />
        )}
      </button>
      {open && (
        <div id={panelId} className={styles.panel}>
          {children}
        </div>
      )}
    </div>
  );
}
